import { render, staticRenderFns } from "./UmanjeniSatDetails.vue?vue&type=template&id=3f56fb46&scoped=true&"
import script from "./UmanjeniSatDetails.vue?vue&type=script&lang=js&"
export * from "./UmanjeniSatDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56fb46",
  null
  
)

export default component.exports